import { render, staticRenderFns } from "./InputNestedObject.vue?vue&type=template&id=a82fb3ba&"
import script from "./InputNestedObject.vue?vue&type=script&lang=js&"
export * from "./InputNestedObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports